__turbopack_context__.v({
  "bottom": "style-module-scss-module__XsaD4q__bottom",
  "callButton": "style-module-scss-module__XsaD4q__callButton",
  "error": "style-module-scss-module__XsaD4q__error",
  "img": "style-module-scss-module__XsaD4q__img",
  "imgWrapper": "style-module-scss-module__XsaD4q__imgWrapper",
  "imgWrapper__hidden": "style-module-scss-module__XsaD4q__imgWrapper__hidden",
  "linear": "style-module-scss-module__XsaD4q__linear",
  "phone_wrap": "style-module-scss-module__XsaD4q__phone_wrap",
  "root": "style-module-scss-module__XsaD4q__root",
  "section": "style-module-scss-module__XsaD4q__section",
  "subtitle": "style-module-scss-module__XsaD4q__subtitle",
  "text": "style-module-scss-module__XsaD4q__text",
  "title": "style-module-scss-module__XsaD4q__title",
  "wrapper": "style-module-scss-module__XsaD4q__wrapper",
});
